<template>
  <div class="edit">
    <div class="table-container">
      <form method="post" @submit.prevent="updateMetalPlace()">
        
        <table id="create_table">
          <caption class="table-naming">Отчет за {{ REPORT.month | getMonth }} {{ REPORT.year }}</caption>
          <thead>
          <th class="metall-left-in-stock-sub-botm" scope="col">Место хранения</th>
          <th class="metall-left-in-stock-sub-botm" scope="col">Вид металла</th>
          <th class="metall-left-in-stock-sub-botm" scope="col">Отстаток металла</th>
          </thead>
          <tbody>
          <tr v-for="(item, index) in inputParam" :key="index">
            <th>
              <select class="metall-table-input" v-model="inputParam[index].place" required :disabled="isForce(index)"
                      @change="checkSelect(index)">
                <option value="">Выберите место хранения</option>
                <option v-for="place in catalog_places" :key="place.id" :value="place.id">{{ place.get_full_name }}
                </option>
              </select>
            </th>
            <th>
              <select class="metall-table-input" v-model="inputParam[index].metal_category" required
                      :disabled="isForce(index)"
                      @change="checkSelect(index)">
                <option value="">Выберите тип металла</option>
                <option v-for="(req_item, req_type) in requests" :key="req_type"
                        :value="req_type">
                  {{ req_type }}
                </option>
              </select>
            </th>
            <td class="metall-info-contract-cell">
              <input class="metall-table-input" type="number" step="0.01" min="0" required
                     v-model="inputParam[index].count_after">
            </td>
          </tr>
          </tbody>
        </table>
        <div class="table-actions">
          <button type="button" class="table-actions-button btn-green"
                @click="addRow()"><i class="fa fa-plus" aria-hidden="true"></i>
        </button>
        <button class="table-actions-button btn-red" v-if="inputParam.length > 0" type="button"
                @click="deleteRow()"
        ><i class="fa fa-minus" aria-hidden="true"></i>
        </button>
        </div>

        <button class="table-actions-button save-btn btn-green" type="submit">
          Сохранить
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {isSaveChange} from "@/variables";

export default {
  name: "EditMetalPlace",
  data() {
    return {
      inputParam: [],
      catalog_places: [],
      requests: [],
      init_length: '',
      is_force: false
    }
  },
  methods: {
    isForce(index) {
      if (this.init_length > index) {
        return this.is_force;
      }
      return false;
    },
    my_remove(arr, index) {
      return [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // part of the array after the specified index
        ...arr.slice(index + 1)
      ];

    },
    checkSelect(index) {
      let place = this.inputParam[index].place;
      let metal_category = this.inputParam[index].metal_category;
      let a = '';
      if (place !== '' && metal_category !== '') {
        for (let i = 0; i < this.inputParam.length; ++i) {
          if (this.inputParam[i].metal_category === metal_category && i !== index && this.inputParam[i].place === place && this.inputParam[i].place !== '' && this.inputParam[i].metal_category !== '') {
            a = index;
            break;
          }
        }
      }
      if (a !== '') {
        this.inputParam = this.my_remove(this.inputParam, a);
      }

    },
    updateMetalPlace() {
      let tmp = JSON.parse(JSON.stringify(this.requests));
      for (let i = 0; i < this.inputParam.length; ++i) {
        if (this.inputParam[i].metal_category !== '' && this.inputParam[i].count_after !== '' && this.inputParam[i].place !== '') {
          if (tmp[this.inputParam[i].metal_category]) {
            this.inputParam[i].request_id = tmp[this.inputParam[i].metal_category][1]
            tmp[this.inputParam[i].metal_category][0] = (tmp[this.inputParam[i].metal_category][0] - this.inputParam[i].count_after).toFixed(2);
          }
        }
      }
      let flag = true;
      let alert_list = [];
      Object.keys(tmp).forEach(function (key) {
        if (tmp[key][0] !== (0).toFixed(2)) {
          flag = false;
          alert_list.push('Вид металла: ' + key + ' переполнен(-)/незаполнен(+): ' + tmp[key][0]);
        }
      });
      for (let i = 0; i < alert_list.length; ++i) {
        this.$store.dispatch("addNotification", {
          type: "error",
          message: alert_list[i],
        });
      }
      if (flag) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: 'Отчет обновлен',
        });
        const formData = {
          inputData: this.inputParam,
          report_id: this.$route.params.id,
          is_save_change: isSaveChange(this.REPORT.status)
        }
        //this.$store.dispatch("createMetalPlace", formData);'
        this.$store.dispatch("updateMetalPlace", formData);
      }
    },
    addRow() {
      let newInputObject = {
        place: '',
        metal_category: '',
        count_after: '',
        request_id: ''
      }
      this.inputParam.push(newInputObject);
    },
    deleteRow() {
      if (this.is_force) {
        if (this.init_length < this.inputParam.length) {
          this.inputParam.pop();
        } else {
          this.$store.dispatch("addNotification", {
            type: "warning",
            message: "Невозможно удаление изначальных данных при корректировке.",
          });
        }
      } else {
        if (this.inputParam.length > 0) {
          this.inputParam.pop();
        }
      }

    },
    getPlaceStartData() {
      this.$store.dispatch('getPlaceStartData', this.$route.params.id).then((response) => {
        this.catalog_places = response.placeCatalogs;
        this.requests = response.requests;
      });
    },
    getReport() {
      this.$store.dispatch('getReport', this.$route.params.id);
    },
    isForceEdit() {
      this.$store.dispatch('isForceEdit', this.$route.params.id).then((response) => {
        this.is_force = response.is_force;
      });
    },
    getInitialData() {
      this.$store.dispatch('getInitialData', this.$route.params.id).then((response) => {
        this.inputParam = response;
        this.init_length = this.inputParam.length;
      });
    },

  },
  mounted() {
    this.getReport();
    this.getPlaceStartData();
    this.getInitialData();
    this.isForceEdit();
  },
  computed: {
    ...
        mapGetters([
          'REPORT',
          'USER'
        ]),
  },
}
</script>

<style scoped>
.duplicate {
  background-color: #717171 !important;
}

.table-container {
  overflow-x: auto;
  padding: 0 2rem;
  /* max-width: 1800px; */
  margin: 0 auto;
}

.table-title {
  padding: 1rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.table-naming {
  font-size: 2rem;
  font-weight: bold;
  padding: 1rem 0;
  /* text-align: left; */
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 1rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

th, td {
  border: 1px solid #868686;
  padding: 1rem;
  /* height: 30px; */
  /* padding-left: ; */
}

th select,
td input {
  border: none;
}

th select:focus,
td input:focus {
  border: none;
  outline: none;
}


/* hidden columns */
.metall-slot-hidden,
.metall-slot-hidden-contract,
.metall-slot-hidden-notes {
  position: relative;
  /* width: 100px; */
  /* height: 75px; */
  display: none;
  border: none;
  /* border-bottom: 1px solid #868686; */
  margin: 0 !important;
}

.metall-slot-hidden p,
.metall-slot-hidden-contract p,
.metall-slot-hidden-notes {
  line-height: 75px;
}

.metall-slot-hidden-notes.top-element {
  border-top: 1px solid black;
}

.metall-table-input {
  width: 100%;
  height: 100%;
  text-align: center;
}


.categories-top-actions {
  margin: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-actions {
  display: flex;
  justify-content: center;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-left: 1rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-upload-file {
  background: none;
  margin-left: -1rem;
}

.btn-green {
  background: #7AD38D;
  color: white;
}

.btn-blue {
  background: #36429E;
  color: white;
}

.total_calculate {
  background: rgba(89, 36, 36, 0.27);
}

.report-table-s {
  height: 100%;
  border: none;
  font-size: .8rem;
  background: none;
  /* text-align: center; */
  margin: 0 auto;
  /* width: 50px !important; */
}

.report-table-s2 {
  height: 100%;
  border: none;
  font-size: .8rem;
  background: none;
}

.custom-th-with-border {
  border: 1px solid #868686;
  background-color: red;
}

.save-btn {
  float: right;
}


</style>